import Util from './libs/util';

const util = new Util();

export default class effectManager {
    constructor(){
        this.$svgTarget = $(".js__tsc-svg-write,.js__svg-write");
    }
    show($target,type,delay,mode){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].getAttribute('class').indexOf('dir-x') != -1){
                        TweenMax.set($target[n],{ opacity:0, x:100});
                    }else if($target[n].getAttribute('class').indexOf('dir-minus-x') != -1){
                        TweenMax.set($target[n],{ opacity:0, x:-100});
                    }else if($target[n].getAttribute('class').indexOf('dir-minus-y') != -1){
                            TweenMax.set($target[n],{ opacity:0, y:-100});
                    }else if($target[n].getAttribute('class').indexOf('dir-none') != -1){
                        TweenMax.set($target[n],{ opacity:0});
                    }else{
                        TweenMax.set($target[n],{ opacity:0, y:50});
                    }
                }

                break;
            case "show":

                // TweenMax.killChildTweensOf($target,{opacity:true,x:true,y:true});

                TweenMax.staggerTo($target,0.9, {
                    y:0,
                    x:0,
                    opacity:1,
                    // scale:1,
                    ease: "Power2.easeOut",
                    delay:delay
                },mode=="short"?0.03:0.06,()=>{
                    if(Useragnt.firefox) TweenMax.set($target,{ opacity:1, x:0,y:0});
                });
                break;
            case "out":
                TweenMax.killChildTweensOf($target,{opacity:true,x:true,y:true});
                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.to($target[n],0.6, {
                            x:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                        });
                    }else{
                        TweenMax.to($target[n],0.6, {
                            y:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                        });
                    }
                }


                // TweenMax.to($target,0.6, {
                //     y:-100,
                //     opacity:0,
                //     // scale:1,
                //     ease: "Power2.easeOut",
                // });
                break;
            case "out2":
                TweenMax.killChildTweensOf($target,{opacity:true,x:true,y:true});
                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.to($target[n],0.6, {
                            x:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:window.innerWidth>750?0.05*n:0.01*n
                        });
                    }else{
                        TweenMax.to($target[n],0.6, {
                            y:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:window.innerWidth>750?0.05*n:0.01*n
                        });
                    }
                }

                break;
            case "outShort":
                TweenMax.killChildTweensOf($target,{opacity:true,x:true,y:true});
                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.to($target[n],0.3, {
                            x:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:0.05*n
                        });
                    }else{
                        TweenMax.to($target[n],0.3, {
                            y:-100,
                            opacity:0,
                            // scale:1,
                            ease: "Power2.easeOut",
                            delay:0.05*n
                        });
                    }
                }

                break;
        }

    }
    showSimple($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target[n],{ opacity:0});
                }

                break;
            case "show":


                TweenMax.staggerTo($target,0.9, {
                    opacity:1,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.1);
                break;
            case "out":
                TweenMax.staggerTo($target,0.9, {
                    opacity:0,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.1);

                break;
        }

    }
    showDelay($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    TweenMax.set($target[n],{ opacity:0});
                }

                break;
            case "show":
                TweenMax.staggerTo($target,0.9, {
                    delay:1.5,
                    opacity:1,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.15);
                break;
            case "out":
                TweenMax.staggerTo($target,0.9, {
                    opacity:0,
                    // scale:1,
                    ease: "Power2.easeOut",
                },0.15);

                break;
        }

    }
    svg($target,type){
        switch (type){
            case "set":
                TweenLite.set($target.querySelectorAll(".js__write"), {drawSVG: "0%",scale:1.2});

                break;
            case "show":
                TweenMax.staggerTo($target.querySelectorAll(".js__write"), 1.8, {
                    drawSVG: "100%",
                    scale:1,
                    // strokeWidth:0.5,
                    // ease: Expo.easeIn
                    // ease: SlowMo.ease.config(0.1, 1.2, false)
                    ease: Power2.easeOut,
                }, .03);
                break;
            case "out":
                TweenMax.staggerTo($target.querySelectorAll(".js__write"), 0.3, {
                    drawSVG: "0%",
                    ease: Power2.easeOut,
                }, .05);
                break;
        }
    }
    splitText($target,type,delay,mode){

        switch (type){
            case "set":

                let chars;

                for( let n in $target ) {
                    if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める

                    let text = new SplitText($target[n], {type:"words,chars"});
                    chars = text.chars;

                    for( let n in chars ) {
                        // TweenMax.set(chars[n],{ opacity:0, y:Math.floor(util.random(20,30))});
                        TweenMax.set(chars[n],{ opacity:0, y:20});
                    }


                }

                break;
            case "show":

                TweenMax.staggerTo($target,0.6,{
                    y:0,
                    opacity:1,
                    ease: Power2.easeOut,
                },0.05);



                // for( let n in $target ) {
                //
                //     if ($target[n].nodeType != 1) continue; // dom要素以外は処理止める
                //     if ($target[n].children.length == 0) continue; // dom要素以外は処理止める
                //     TweenMax.to($target[n].children,0.8,{
                //         opacity:1,
                //         // scale:1,
                //         x:0,
                //         y:0,
                //         ease: Power2.easeOut,
                //         delay:delay + 0.3*n
                //     });
                // }

                break;
            case "out":
                TweenMax.to($target, 0.4,
                    {
                        opacity:0,
                        // filter:"blur(0px)",
                        ease: "Power2.easeIn",
                        onComplete:()=>{
                            for( let n in $target ) {
                                if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                                TweenMax.set($target[n],{x:Math.floor(util.random(-30,30)),y:Math.floor(util.random(-30,30))});
                            }
                        }
                    });
                break;
        }

    }
    panel($target,type){

        switch (type){
            case "set":

                for( let n in $target ){
                    if($target[n].nodeType!=1) continue; // dom要素以外は処理止める
                    if($target[n].classList.contains("dir-x")){
                        TweenMax.set($target[n],{x:0+"%"});
                    }else{
                        TweenMax.set($target[n],{ y:0+"%"});
                    }
                }


                break;
            case "show":


                TweenMax.staggerTo($target,1.6, {
                    x:101+"%",
                    y:0+"%",
                    // scale:1,
                    ease: Expo.easeOut,
                },0.1);
                break;
            case "out":
                TweenMax.to($target,0.9, {
                    x:101+"%",
                    // scale:1,
                    ease: "Power2.easeOut",
                });

                break;
        }

    }
    scale($target,type){

        switch (type){
            case "set":

                TweenMax.set($target,{scale:1.4,opacity:0});

                break;
            case "show":


                TweenMax.staggerTo($target,1.6, {
                    scale:1,
                    opacity:1,
                    delay:0.2,
                    ease: Power2.easeOut,
                },0.1);
                break;
            case "out":
                TweenMax.to($target,0.9, {
                    scale:1.2,
                    opacity:0,
                    ease: "Power2.easeOut",
                });

                break;
        }

    }
    circle($target,type){

        switch (type){
            case "set":

                TweenMax.set($target,{borderWidth:0});

                break;
            case "show":


                TweenMax.to($target,2, {
                    width:0+"%",
                    height:0+"%",
                    opacity:0,
                    ease: Power0.easeNone,
                },0.1);
                break;
            case "out":
                TweenMax.to($target,0.9, {
                    x:101+"%",
                    // scale:1,
                    ease: "Power2.easeOut",
                });

                break;
        }

    }

}
